import * as Yup from 'yup'

export const validationSchema = t => {
    return {
        email: Yup.string()
            .typeError(t('validation.valid.char'))
            .email(t('validation.invalid.email'))
            .required(t('validation.enter.email'))
            .test('existing', t('validation.existing.email'), function (email) {
                return !this.parent.sharedWith?.some(e => e.email === email)
            })
            .test('agreement', t('validation.agreement.email'), function (email) {
                return !this.parent.agreementUsers?.some(e => e.emailId === email)
            }),
    }
}
